// extracted by mini-css-extract-plugin
export default {"paginationDiv":"Pagination_paginationDiv__G-agC","pageItem":"Pagination_pageItem__2olvc"};